import {
  Directive,
  Input,
  HostListener,
  Renderer2,
  OnInit,
  inject
} from '@angular/core';

@Directive({ selector: '[mExpandable]' })
export class MExpandableDirective implements OnInit {
  private readonly renderer = inject(Renderer2);

  @Input() targetSelector!: string;
  private expanded = false;

  ngOnInit() {
    const target = document.querySelector(this.targetSelector) as HTMLElement;
    if (target) {
      this.renderer.setStyle(target, 'max-height', '0');
      this.renderer.setStyle(target, 'overflow', 'hidden');
      this.renderer.setStyle(target, 'opacity', '0');
      this.renderer.setStyle(
        target,
        'transition',
        'opacity 0.5s ease-in-out, max-height 0.5s ease-in-out'
      );
    }
  }

  @HostListener('click')
  toggle() {
    const target = document.querySelector(this.targetSelector) as HTMLElement;

    if (!target) {
      console.error(
        `Expandable target element not found for selector: ${this.targetSelector}`
      );
      return;
    }

    if (this.expanded) {
      this.renderer.setStyle(target, 'max-height', '0');
      this.renderer.setStyle(target, 'opacity', '0');
    } else {
      this.renderer.setStyle(target, 'max-height', target.scrollHeight + 'px');
      this.renderer.setStyle(target, 'opacity', '1');
    }

    this.expanded = !this.expanded;
  }
}
